import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CreditosService } from '../../../../services/creditos.service'; 
import { ConveniosService } from '../../../../services/convenios.service';
import { HelpersService } from '../../../../services/tools/helpers.service';
@Component({
  selector: 'app-editar-convenio-credit',
  templateUrl: './editar-convenio-credit.component.html',
  styleUrls: ['./editar-convenio-credit.component.scss']
})
export class EditarConvenioCreditComponent implements OnInit {
  public credit_info;
  public convenios_info;
  public convenio_selected;
  constructor(
    private creditosService: CreditosService,
    private conveniosservice: ConveniosService,
    private helperService: HelpersService,
    @Inject (MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<EditarConvenioCreditComponent>,
  ) { }

  ngOnInit() {
    this.convenio_selected = this.data.convenio_id;
    this.creditosService.get(this.data.id).subscribe(
      (response)=>{
        const jsonResult = response.json();
        this.credit_info = jsonResult.content
        this.convenio_selected = jsonResult.content.convenio_str;

      }, (error) =>{
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
    this.conveniosservice.getAll({}).subscribe(
      (response)=>{
        const jsonResult = response.json();
        this.convenios_info = jsonResult.content
      }, (error) =>{
        // se resuelve error 403 y 500
        this.helperService.httpGlobalError(error);
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }

  public cerrar(){ 
    this.dialogRef.close({editar:false});
  }

  public aceptar(){
    let temp = this.convenios_info.find(item => item.razon_social == this.convenio_selected);
    console.log(temp);
    this.credit_info.convenio_str=temp.razon_social || ""
    this.credit_info.idConvenio=temp.id || 0
    this.creditosService.update(this.credit_info).subscribe(
      (response)=>{
        console.log("Actualizado");
        this.dialogRef.close({editar:true});
        this.helperService.notification('Credito actualizado', 'Se ha actualizado exitosamente', 'success');
      },(error)=>{
        this.helperService.httpGlobalError(error);
        this.dialogRef.close({editar:false});
        if(error.status == 400) {
          this.helperService.notification('ERROR', 'No se completó la acción. Por favor, intenta más tarde.', 'error');
        }
      }
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/components/tools/modals/editar-convenio-credit/editar-convenio-credit.component.ts